


import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import { SearchResults } from "../../models/search-viewmodel";

import ResultComponent from '../Result/Result.vue';

@Component({
    components: {
        ResultComponent
    },
    computed: {
        ...mapGetters(["searchResults", "searchQuery", "loading", "config"])
    },
})
export default class ResultsListComponent extends Vue {
    @Prop() results!: SearchResults;
    @Prop({default: false}) showCount!: boolean;
    @Prop() linkText!: string;
    @Prop() noResultsLinkText!: string;
    @Prop() overviewUrl!: string;
    @Prop() overviewUrlTarget!: string;
}
